<div #chartTarget class="wide tall" [class.invisible]="loading$ | async"></div>

<div class="auto-mask hide-mask" *ngIf="loading$ | async">
    <span class="mask-message">
        <span>{{ getMaskText() }}</span>
    </span>
</div>
